import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';

export class ReferralExportMapper {
  static toCsvExport(rows: any[], fileName: string): CsvExport {
    const headers = [
      'Date Open',
      'Referred By',
      'Type',
      'Status',
      'Rejected By',
      'Date Closed',
    ];

    const dataRows = rows.map((row) => [
      this.formatDate(row.dateOpen),
      row.referredBy || '',
      row.type || '',
      row.status || '',
      row.rejectedBy || '',
      this.formatDate(row.dateClosed),
    ]);

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = [
      'Date Open',
      'Referred By',
      'Type',
      'Status',
      'Rejected By',
      'Date Closed',
    ];

    const dataRows = rows.map((row) => [
      this.formatDate(row.dateOpen),
      row.referredBy || '',
      row.type || '',
      row.status || '',
      row.rejectedBy || '',
      this.formatDate(row.dateClosed),
    ]);

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static formatDate(value: any): string {
    if (!value) return '';
    if (value === '0001-01-01T00:00:00') return '';
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    }
    return '';
  }
}
